export default __webpack_public_path__ + "static/media/arrow_btn@2x.df9bb17a.svg";